module.exports = __webpack_public_path__ + "media/application/images/ui/Jon_signature-3b96d98bf0631f614233278ec8787cd0.png";